// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    subscriptions: [],
    count: 0,
};

const slice = createSlice({
    name: 'subscription',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // GET SUBINDUSTRYS
        getSubscriptionsSuccess(state, action) {
            state.subscriptions = action.payload;
        },

    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getSubscriptions(data) {
    return async () => {
        try {
            const response = await axios.get('/api/subscription/list',
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                },
                params: data
            }
            );
            dispatch(slice.actions.getSubscriptionsSuccess(response.data.subscriptionPlanList));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

